module.exports = __webpack_public_path__ + "img/camam.8bb796ec.svg";